module.exports = __webpack_public_path__ + "img/cartao_diners.1cdebffc.png";